Pegasus.TemplateContentView = Ember.View.extend({
  classNames: ['vr-template-content'],
  controllerBinding: 'parentView.controller',
  template: function(){
    return Ember.Handlebars.compile( this.get('controller.content.html') );
  }.property(),
  isVisible: true,

  isReady: false,

  bindClickEditingBehavior: function(){
    $('.center-wrapper-container').on('click.' + this.get('elementId'), function(e){
      if ( $(e.target).hasClass('center-wrapper-container') ) {
        Em.run(Pegasus.stateMachine, 'send', 'didFinishEditing');
      }
    });
  },

  bindBlockHiding: function(){
    $(window).on([
      'didToggleImageDisplayMode.' + this.get('elementId'),
      'considerHidden.' + this.get('elementId')
    ].join(' '), function(){
      Em.run.scheduleOnce('afterRender', this, 'updateHasHidden');
    }.bind(this));
  },

  updateHasHidden: function(){
    if ( this.$('.user-hidden').length ) {
      this.set('controller.hasHidden', true);
      return;
    }
    this.set('controller.hasHidden', false);
  },

  unbindBlockHiding: function(){
    $(window).off([
      'didToggleImageDisplayMode.' + this.get('elementId'),
      'considerHidden.' + this.get('elementId')
    ].join(' '))
  },

  unbindWrapperClick: function(){
    $('.center-wrapper-container').off('click.' + this.get('elementId'));
  },

  willDestroyElement: function(){
    this.unbindBlockHiding();
    this.unbindWrapperClick();
    this._super();
  },

  didInsertElement: function(){
    this._super();

    // we have a lot of didInsert logic so let the dust
    // settle before allowing any interactio
    Pegasus.set('status', 'editing');

    if( Pegasus.stateMachine.isDone ){
      Pegasus.stateMachine.isDone();
    }

    this.bindClickEditingBehavior();
    this.bindBlockHiding();
  }
});

Pegasus.TemplateView = Ember.View.extend({
  classNames: ['editor-container'],
  templateName: 'template/index',
  contentView: Pegasus.TemplateContentView,

  documentURL: window.documentURL,

  init: function(){
    this._super();
    $(window).on('didLoadDocument', this.didLoadDocument.bind(this));
  },
  didLoadDocument: function(e, frame){
    window.vrChildWindow = frame.contentWindow;
  },
  resize: function(){
    if ( ! this.$() ) { return; }
    var doc = this.$('#pegasus_document');
    if ( ! doc ) { return; }

    var scale = this.get('controller.currentZoomValue');
    if ( scale == 100 ) {
      doc.removeAttr('width');
      doc.removeAttr('height');
      doc.css('flex', '1 1 auto');
      return;
    }

    doc.css('flex', '0 0 auto');

    var factor = 100/scale;
    var parentWidth = doc.parent().width();
    var parentHeight = doc.parent().height();

    width = parentWidth * factor;
    height = parentHeight * factor;

    doc.attr('width', width);
    doc.attr('height', height);
  }.observes('controller.currentZoomValue'),
  bindResize: function(){
    $(window).on('resize.document', this.resize.bind(this));
  },
  unbindResize: function(){
    $(window).off('resize.document');
  },
  willDestroyElement: function(){
    this.unbindResize();
    this._super();
  },
  didInsertElement: function(){
    this._super();
    this.bindResize();
    this.activeDocumentChanged();
  },
  loadedDocuments: [],
  focusActive: function(){
    var active = this.get('controller.activeDocument.uniqueID');
    var frames = this.$('iframe');
    frames.hide()

    var activeFrame = this.$('iframe[name="'+active+'"]')
    $('.document-tab').removeClass('active');
    $('.document-tab.'+active).addClass('active');
    this.get('controller').didActivateFrame( activeFrame[0], frames );
    activeFrame.show();
  },
  activeDocumentChanged: function(){
    if ( !this.$() ) { return; }
    var newDoc = this.get('controller.activeDocument');
    if ( !newDoc ) { return; }

    var activeIds = this.get('loadedDocuments').mapProperty('uniqueID');

    if ( ! activeIds.contains( newDoc.uniqueID ) ) {
      this.get('loadedDocuments').pushObject( newDoc );
    }

    Em.run.scheduleOnce('afterRender', this, 'focusActive');
  }.observes('controller.activeDocument')
});
